import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import {
  SalesArguments,
  CreateSalesArgument,
  UpdateSalesArgument,
  ImportSalesArguments,
} from "./pages";

export const SalesArgumentsRouter = [
  <Route
    path="/sales-arguments"
    element={
      <ProtectedRoute roles={["Any"]}>
        <SalesArguments />
      </ProtectedRoute>
    }
  />,

  <Route
    path="/sales-arguments/import"
    element={
      <ProtectedRoute roles={["Any"]}>
        <ImportSalesArguments />
      </ProtectedRoute>
    }
  />,

  <Route path="/sales-argument">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateSalesArgument />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateSalesArgument />
        </ProtectedRoute>
      }
    />
  </Route>,
];
